import {
    useMemo,
} from 'react'
import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import {
    FeesType,
} from 'app/enums/common.enums'
import laneFeesRequests from 'app/requests/ContractBasis/LaneFees.requests'
import additionalFeesRequests from 'app/requests/ContractBasis/AdditionalFees.requests'
import longTermLeaseFeesRequests from 'app/requests/ContractBasis/LongTermLeaseFees.requests'
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type Mapping = Record<string, string[]>

const requestKeyByType: Record<FeesType, RequestKeys> = {
    [FeesType.Lane]: RequestKeys.getAllowedLaneFeesFeeNameToChargeAbilityMapping,
    [FeesType.OtherFees]: RequestKeys.getAllowedLaneFeesFeeNameToChargeAbilityMapping,
    [FeesType.Additional]: RequestKeys.getAllowedAdditionalFeesFeeNameToChargeAbilityMapping,
    [FeesType.LongTermLease]: RequestKeys.getAllowedLongTermFeesFeeNameToChargeAbilityMapping,
}

const requestFnByType: Record<FeesType, RequestConfigFunction> = {
    [FeesType.Lane]: laneFeesRequests.getAllowedFeeNames,
    [FeesType.OtherFees]: laneFeesRequests.getAllowedFeeNames,
    [FeesType.Additional]: additionalFeesRequests.getAllowedFeeNames,
    [FeesType.LongTermLease]: longTermLeaseFeesRequests.getAllowedFeeNames,
}

const useFeesNameToFeesChargeabilityMapping = (type: FeesType): Mapping => {
    const {
        isDataReady,
        data,
    } = useRequest<Mapping>({
        key: requestKeyByType[type],
        requestFunc: RequestFn.getEntity(requestFnByType[type]),
        staleTime: Infinity,
        enabled: Boolean(requestKeyByType[type] && requestFnByType[type]),
    })

    return useMemo(() => {
        if (isDataReady && data) {
            return data
        }
        return undefined
    }, [
        data,
        isDataReady,
    ])
}

export default useFeesNameToFeesChargeabilityMapping
